import { observer } from 'mobx-react';

import Icon from '../../../app/shared/components/Icon/Icon';
import Link from '../../../app/shared/components/Link';
import { AdminPolicy } from '../../Policy';
import StoreDisplayName from './StoreDisplayName/StoreDisplayName';
import StoreSelector from './StoreSelector/StoreSelector';
import css from './UserInfo.css';
import UserInfoState from './UserInfoState';

interface UserInfoProps {
  state: UserInfoState;
}

const UserInfo = ({ state }: UserInfoProps) => {
  const customer = state.shoppingContext.customer;
  const isHubAdmin = customer && customer.isRegistered && AdminPolicy.grantAccess(customer);

  return (
    <div className={css.UserInfo}>
      <Link className={css.user} to={state.profileUrl}>
        <Icon name="user" className={css.icon} />
        <span className={css.name}>{state.name}</span>
      </Link>
      {isHubAdmin && state.hasAccessToMultipleStores ? (
        <StoreSelector state={state.storeSelector} />
      ) : (
        <StoreDisplayName storeId={state.store.id} className={css.context} storeName={state.store.displayName} />
      )}
      {state.pricingContext.currency && (
        <span className={css.context}>
          {state.translation.pricingContextFormat.interpolate([['currency', state.pricingContext.currency]])}
        </span>
      )}
    </div>
  );
};

export default observer(UserInfo);
